import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { ISortCode } from '../util/DataModelInterface';

export const getSortCodes = async (force: boolean = false) => {
  let sortCodes = storage.getSortCodes();
  if (!sortCodes ||sortCodes.length === 0 || force) {
    const url = `${getFunctionBaseUrl()}/api/sortCodes`;
    const response: ISortCode[] = await rest.get(url);
    sortCodes = response;
    storage.setSortCodes(sortCodes);
  }
  return sortCodes;
}